var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5 7C5 5.89543 5.89543 5 7 5H17C18.1046 5 19 5.89543 19 7V13H5V7Z", stroke: "#303030", strokeWidth: "1.5" }),
    React.createElement("path", { d: "M8 13V19M4 13V19M12 5L12 19M16 13V19M20 13V19M3 19L21 19M3 13L21 13", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" })
  );
});